import React, { PropTypes as T } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues } from 'redux-form/immutable';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';

import RadioInput from '../../components/form-input-radio';
import SelectInput from '../../components/form-input-select';
import TextInput from '../../components/form-input-text';
import TextArea from '../../components/form-input-textarea';
import { sendDeliverableAll } from './actions';
import { SEND_DELIVERABLE_ALL, FACEBOOK, TWITTER, INSTAGRAM, YOUTUBE, SNAPCHAT, VIDEO, IMAGE, TEXT, BLOG, OTHER } from '../../utils/static-configuration';
import { clearModal } from '../../actions/modal';

class SendDeliverableAll extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      focused: false,
      liveFocused: false,
    };
  }

  onOutsideClick(event) {
    let isClickInside = this.refs.modal_content.contains(event.target);
    if (!isClickInside) {
      this.props.onClearModal();
    }
  }

  resetForm = () => {
    this.props.reset();
    this.props.onClearModal();
  };

  formatDeliverableFormData = formData => {
    const title = formData.get('title');
    let channelType = formData.get('channelType');
    if (channelType === OTHER) channelType = formData.get('otherChannelType');

    const assetType = [formData.get('assetType')];
    const description = formData.get('description');
    const dueDate = formData.get('dueDate').toISOString();
    const liveDateEnd = formData.get('liveDate').toISOString();

    const deliverableData = {
      title,
      channelType,
      assetType,
      dueDate,
      liveDateEnd,
      description,
    };

    return deliverableData;
  };

  submitSendDeliverableAll = formData => {
    const deliverableData = this.formatDeliverableFormData(formData);
    this.props.onSendDeliverableAll(deliverableData, this.resetForm);
  };

  componentWillUnmount() {
    this.resetForm();
  }

  render() {
    const {
      handleSubmit,
      showModal,
      onClearModal,
      modalLoading,
      formValues,
    } = this.props;

    const channelTypeSelected = formValues ? formValues.get('channelType') : null;
    const channelTypeOptions = [
      { value: YOUTUBE, label: 'Youtube' },
      { value: FACEBOOK, label: 'Facebook' },
      { value: INSTAGRAM, label: 'Instagram' },
      { value: TWITTER, label: 'Twitter' },
      { value: SNAPCHAT, label: 'Snapchat' },
      { value: OTHER, label: 'Other' },
    ];

    return (
      <div className={showModal === SEND_DELIVERABLE_ALL ? 'custom-modal visible' : 'custom-modal'} onClick={this.onOutsideClick.bind(this)}>
        <form onSubmit={handleSubmit(this.submitSendDeliverableAll)}>
          <div className="modal-content" ref="modal_content">
            <div className="top-text">
              <h3>Assign a deliverable for everyone</h3>
              <p>This will be sent to all influencers on this campaign.</p>
            </div>
            <div className="modal-close large">
              <img src="/icons/close.svg" alt="close" onClick={() => onClearModal()} />
            </div>
            <div className="center">
              <table>
                <tbody>
                  <tr>
                    <td width="150px">
                      <h4>Title</h4>
                    </td>
                    <td colSpan="2">
                      <Field
                        name="title"
                        type="text"
                        label=""
                        component={TextInput}
                        placeholder="Deliverable title"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width="150px">
                      <h4>Channel type</h4>
                    </td>
                    <td colSpan="2">
                      <Field
                        name="channelType"
                        component={props => (
                          <SelectInput
                            name="channelType"
                            label=""
                            className="stacked"
                            {...props}
                            options={channelTypeOptions}
                          />
                        )}
                      />
                    </td>
                  </tr>
                  { channelTypeSelected === OTHER &&
                    <tr>
                      <td width="150px" />
                      <td colSpan="2">
                        <Field
                          name="otherChannelType"
                          type="text"
                          label=""
                          component={TextInput}
                          placeholder="channel name"
                        />
                      </td>
                    </tr>
                  }
                  <tr>
                    <td width="150px">
                      <h4>Asset type</h4>
                    </td>
                    <td colSpan="2">
                      <div className="checkbox-wrapper">
                        <div className="checkbox-row">
                          <span>
                            <Field
                              id="Video"
                              type="radio"
                              component={RadioInput}
                              name="assetType"
                              value={VIDEO}
                              label="Video"
                            />
                          </span>
                          <span>
                            <Field
                              id="Image"
                              type="radio"
                              component={RadioInput}
                              name="assetType"
                              value={IMAGE}
                              label="Image"
                            />
                          </span>
                        </div>
                        <div className="checkbox-row">
                          <span>
                            <Field
                              id="Blog"
                              type="radio"
                              component={RadioInput}
                              name="assetType"
                              value={BLOG}
                              label="Blog"
                            />
                          </span>
                          <span>
                            <Field
                              id="Text"
                              type="radio"
                              component={RadioInput}
                              name="assetType"
                              value={TEXT}
                              label="Text"
                            />
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="150px">
                      <h4>Due date</h4>
                    </td>
                    <td colSpan="2">
                      <div className="datepicker-wrapper">
                        <Field
                          name="dueDate"
                          component={props => {
                            const { input: { value, onChange } } = props;
                            return (
                              <div>
                                <SingleDatePicker
                                  id="dueDate"
                                  {...props}
                                  date={value}
                                  focused={this.state.focused}
                                  numberOfMonths={1}
                                  displayFormat={'DD/MM/YYYY'}
                                  placeholder="Select date"
                                  onDateChange={date => onChange(date)}
                                  onFocusChange={({ focused }) => this.setState({ focused })}
                                />
                                { props.meta.touched && props.meta.error &&
                                  <p className="small error">
                                    { props.meta.error }
                                  </p>
                                }
                              </div>
                            );
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="150px">
                      <h4>Live date</h4>
                    </td>
                    <td colSpan="2">
                      <div className="datepicker-wrapper">
                        <Field
                          name="liveDate"
                          component={props => {
                            const { input: { value, onChange } } = props;
                            return (
                              <div>
                                <SingleDatePicker
                                  id="liveDate"
                                  {...props}
                                  date={value}
                                  focused={this.state.liveFocused}
                                  numberOfMonths={1}
                                  displayFormat={'DD/MM/YYYY'}
                                  placeholder="Select date"
                                  onDateChange={date => onChange(date)}
                                  onFocusChange={({ focused }) => this.setState({ liveFocused: focused })}
                                />
                                { props.meta.touched && props.meta.error &&
                                  <p className="small error">
                                    { props.meta.error }
                                  </p>
                                }
                              </div>
                            );
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td width="150px">
                      <h4>Requirements <span className="light">(optional)</span></h4>
                    </td>
                    <td colSpan="2">
                      <Field
                        name="description"
                        component={TextArea}
                        placeholder="e.g. video length, image size, copy or required hashtags"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="3">
                      <div className="spacer" />

                      <button className="medium rose stretch" type="submit">
                        { modalLoading
                          ? <ul className="dots">
                              <li id="dot1" />
                              <li />
                              <li id="dot2" />
                              <li />
                              <li id="dot3" />
                            </ul>
                          : <span>Assign deliverable</span>
                        }
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const title = values.get('title');
  const channelType = values.get('channelType');
  const otherChannelType = values.get('otherChannelType');
  const assetType = values.get('assetType');
  const dueDate = values.get('dueDate');
  const liveDate = values.get('liveDate');

  if (!title) errors.title = 'Please enter a title';
  if (!channelType) errors.channelType = 'Please select a channel type';
  if (channelType === OTHER && !otherChannelType) errors.channelType = 'Please enter a channel type';
  if (!assetType) errors.assetType = 'Please select an asset type';
  if (!dueDate) errors.dueDate = 'Please select a due date';
  if (!liveDate) errors.liveDate = 'Please select a live date';
  if (dueDate && liveDate && dueDate.isAfter(liveDate)) errors.liveDate = 'Live date must be after due date';

  return errors;
}

const getDeliverableChannelType = channelType => {
  if (!channelType) return '';
  if (channelType === FACEBOOK || channelType === TWITTER || channelType === INSTAGRAM || channelType === YOUTUBE || channelType === SNAPCHAT) {
    return channelType;
  }
  return OTHER;
};

const getOtherChannelTypeInput = channelType => {
  if (!channelType) return '';
  if (channelType === FACEBOOK || channelType === TWITTER || channelType === INSTAGRAM || channelType === YOUTUBE || channelType === SNAPCHAT) {
    return '';
  }
  return channelType;
};

const mapStateToProps = state => {
  return {
    formValues: getFormValues('SendDeliverableAll')(state),
    showModal: state.modal.get('showModal'),
    modalLoading: state.modal.get('loading'),
    modalError: state.modal.get('error'),
    initialValues: {
      dueDate: moment().add(7, 'days'),
      liveDate: moment().add(2, 'weeks'),
    },
  };
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onSendDeliverableAll: (deliverableData, createDeliverableCallback) => dispatch(sendDeliverableAll(deliverableData, createDeliverableCallback)),
    onClearModal: () => dispatch(clearModal()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'SendDeliverableAll',
    validate,
  })(SendDeliverableAll),
);



/** WEBPACK FOOTER **
 ** ./src/containers/send-deliverable-all-modal/index.js
 **/